import { Component, OnInit, OnDestroy } from '@angular/core';

import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ManagmentCardComponent } from './managment-card/managment-card.component';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Subscription } from 'rxjs';
import { ServiceNovoStudioModel } from 'src/models/pilotage/serviceNovoStudioModel';
import { EEntite } from 'src/enum/eEntite';

@Component({
    selector: 'app-tableau-de-bord',
    templateUrl: './tableau-de-bord.component.html',
    styleUrls: ['./tableau-de-bord.component.scss'],
    imports: [RouterModule, TranslateModule, ManagmentCardComponent, MatIcon, MatTooltipModule]
})
export class TableauDeBordComponent implements OnInit, OnDestroy {
  private entiteChangeSubscription?: Subscription;

  constructor(public utilisateurService: UtilisateurService) { }

  get afficheChoixRoot(): boolean {
    return (this.utilisateurService.selectionEntiteUtilisateur?.estRoot ||
      this.utilisateurService.selectionEntiteUtilisateur?.estRootLectureSeule) &&
      this.utilisateurService.entiteUtilisateurSelectionnee?.entiteId === EEntite.ROOT_ENTITE_ID;
  }

  public get isModeRoot(): boolean {
    return this.utilisateurService.isModeRoot;
  }

  ngOnInit(): void {
    this.chargerServicesEntiteActive();

    this.entiteChangeSubscription = this.utilisateurService.entiteSelectionChange.subscribe(() => {
      this.chargerServicesEntiteActive();
    });
  }

  ngOnDestroy(): void {
    this.entiteChangeSubscription?.unsubscribe();
  }

  private chargerServicesEntiteActive(): void {
    const entiteSelectionnee = this.utilisateurService.entiteUtilisateurSelectionnee;
    if (entiteSelectionnee?.novoEntiteId) {
      this.utilisateurService.obtenirServicesEntiteEtAccesDiffusion(entiteSelectionnee.novoEntiteId).subscribe({
        next: (services: ServiceNovoStudioModel) => {
          entiteSelectionnee.estDemo = services.estDemo;
          entiteSelectionnee.dateDebutDemo = services.dateDebutDemo ?? null;
          entiteSelectionnee.dateFinDemo = services.dateFinDemo ?? null;
          entiteSelectionnee.estServiceStudio = services.estServiceStudio ?? false;
          entiteSelectionnee.estServiceStudioContenusPerso = services.estServiceStudioContenusPerso ?? false;
          entiteSelectionnee.aAccesDiffusion = services.aAccesDiffusion ?? false;
          entiteSelectionnee.aAccesIndex = services.aAccesIndex ?? false;
        },
        error: (error) => {
          console.error('Erreur lors du chargement des services de l\'entité:', error);
        }
      });
    }
  }

  get estServiceContenusPersonnalisesActive(): boolean {
    return this.utilisateurService.entiteUtilisateurSelectionnee?.estServiceStudioContenusPerso ?? false;
  }

  get aAccesDiffusion(): boolean {
    return this.utilisateurService.entiteUtilisateurSelectionnee?.aAccesDiffusion ?? false;
  }

  get aAccesIndex(): boolean {
    return this.utilisateurService.entiteUtilisateurSelectionnee?.aAccesIndex ?? false;
  }

  get afficheContenusPerso(): boolean {
    const estRoot = this.utilisateurService.selectionEntiteUtilisateur?.estRoot ||
      this.utilisateurService.selectionEntiteUtilisateur?.estRootLectureSeule;

    if (this.utilisateurService.entiteUtilisateurSelectionnee?.entiteId === EEntite.ROOT_ENTITE_ID) {
      return false;
    }

    return estRoot || this.estServiceContenusPersonnalisesActive;
  }
}
